import React from "react";
import { Create, type CreateProps } from "react-admin";
import { FmbContributionCategoryForm } from "./FmbContributionCategoryForm";

export default function FmbContributionCategoryCreate(props: CreateProps) {
  return (
    <Create {...props} mutationMode="pessimistic" title="Create Contribution Category">
      <FmbContributionCategoryForm />
    </Create>
  );
}
